import React from "react";

const SortOrderHeader = ({ displayName, sortField, activeSort, setSortOrderParent }) => {
  const isActive = activeSort?.sort_by === sortField;
  const currentOrder = isActive ? activeSort?.sort_type : null;

  const handleClickSort = () => {
    let newOrder;
    if (!isActive) {
      newOrder = "asc";
    } else if (currentOrder === "asc") {
      newOrder = "desc";
    } else if (currentOrder === "desc") {
      newOrder = null;
    }

    setSortOrderParent?.(newOrder ? { sort_by: sortField, sort_type: newOrder } : null);
  };

  return (
    <div
      className="flex items-center gap-2 justify-content-between cursor-pointer select-none w-full"
      onClick={handleClickSort}
      title={`Klik untuk mengurutkan ${displayName}`}
    >
      <span className="font-semibold text-blue-600">{displayName}</span>
      {isActive && currentOrder && (
        <i className={`text-gray-500 text-xs pi ${currentOrder === "asc" ? "pi-arrow-up" : "pi-arrow-down"}`}></i>
      )}
    </div>
  );
};

export const ColumnCutRecap = (handleSortOrder, activeSort) => {
  return [
    {
      headerName: "No",
      field: "no",
      width: 80,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
    },
    {
      headerName: "Worker ID",
      field: "workerId",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker ID",
        sortField: "worker_id",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Name",
      field: "workerName",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Name",
        sortField: "worker_name",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Type",
      field: "workerType",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Type",
        sortField: "worker_type",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Amount",
      field: "amount",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Total",
        sortField: "amount",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
    },
    {
      headerName: "Bank",
      field: "bankCode",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank",
        sortField: "bank_code",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Bank Account",
      field: "bankAccountName",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank Account",
        sortField: "bank_account_name",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Bank Number",
      field: "bankAccount",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank Number",
        sortField: "bank_account",
        setSortOrderParent: handleSortOrder,
        activeSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
  ];
};
